module.exports = __webpack_public_path__ + "AiBot_Iconwp44a2f1956558a6e29c135f55a57e1038.svg";